import * as React from 'react';
import b_ from 'b_';
import { compose } from 'recompose';
import Tooltip from 'shared/components/Tooltip';
import { Money } from 'shared/types/common';
import MoneyView from 'shared/components/MoneyView';
import translate, { InjectedTranslateProps } from 'shared/utils/translate';

import './index.scss';

const b = b_.with('current-price');

interface ICurrentPrice {
  price: Money;
}

interface Props {
  children: ICurrentPrice | null;
}

type Enhanced = Props & InjectedTranslateProps;

const enhance = compose<Enhanced, Props>(translate);

class CurrentPrice extends React.Component<Enhanced> {
  render() {
    const { children } = this.props;

    if (children === null) {
      return <span>— {this.renderComment()}</span>;
    }

    const { price } = children;

    return (
      <span>
        <SmartMoneyView>{price}</SmartMoneyView>
      </span>
    );
  }

  private renderComment() {
    const { t } = this.props;

    return (
      <Tooltip
        placement="top"
        trigger={['hover']}
        overlay={
          <div className={`rc-overlay ${b('tooltip')}`}>{t('Cannot get current price')}</div>
        }
      >
        <span className={b('comment-icon')}>?</span>
      </Tooltip>
    );
  }
}

export default enhance(CurrentPrice);

const SmartMoneyView: React.SFC<{ children: Money | null }> = (props) => {
  const price = props.children;
  if (!price) {
    return <MoneyView {...props} />;
  }
  const limit = 100;
  return <MoneyView {...props} precision={price.value < limit ? 2 : 0} />;
};
